<template>
  <div>
    <ul class="head">
      <li class="lf48"><img src="../../static/images/logo.png" alt=""></li>
      <li class="title">投放管理平台</li>
      <li class="f-right out">
        <label @click="logout">退出</label>
      </li>
      <li class="f-right" style="position:relative;top:-8px;">
        <p style='font-size: 14px;height:20px;'>{{deData.accountName}}</p>
        <p style='font-size: 12px;height:20px;'>{{deData.account|mobile}}</p>
      </li>
      <li class="f-right"><img class="rt" src="../../static/images/head.png" alt=""></li>
    </ul>
  </div>
</template>
<script>
import { indexApi } from "../axios/index";
export default {
  props:{
    deData:{
      type:Object,
      default:{}
    }
  },
  data(){
    return{
    }
  },
  methods:{
    logout(){
      indexApi.logout().then(data=>{
        if(data.status==1){
          localStorage.removeItem("userInfo");
          this.$router.push({path:'/'})
        }else{
          msgError(data.message)
        }
      });
    }
  
  },
  mounted(){
  }
}
</script>
<style scoped>
  .head{
    height: 80px;
    line-height: 80px;
    background: #2E62C9;
    position: fixed;
    width: 100%;
    z-index: 999;
  }
  .head li{
    max-width: 300px;
    float: left;
    font-size: 18px;
    font-weight: 600;
    color: #FFFFFF;
  }
  .head img{
    vertical-align: middle;
    width: 150px;
    position: relative;
    top:-1px;
  }
  .head img.rt{
    width:20px;
  }
  .lf48{
    margin-left: 48px;
  }
  .title{
    margin-left: 20px;
  }
  .f-right{
    float: right !important;
    margin-right: 20px;
  }
  .out label{
    padding: 10px 20px;
    background: #FFFFFF;
    border-radius: 4px;
    font-size: 14px;
    color: #2E62C9;
    cursor: pointer;
    height: 35px;
    line-height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue